// extracted by mini-css-extract-plugin
export var actions = "_4-0";
export var actionsContainer = "_4-7";
export var border = "_4-1";
export var childFullHeight = "_4-g";
export var collapse = "_4-2";
export var content = "_4-b";
export var contentChild = "_4-f";
export var fullscreen = "_4-d";
export var hasLeftRadius = "_4-l";
export var headerContainer = "_4-3";
export var headerRow = "_4-5";
export var hidePadding = "_4-c";
export var navCollapsedGap = "_4-m";
export var noScrollX = "_4-n";
export var noScrollY = "_4-o";
export var noTopPadding = "_4-j";
export var optOutTopPadding = "_4-e";
export var pageMain = "_4-k";
export var pageOuter = "_4-h";
export var pagePadding = "_4-8";
export var pageScroll = "_4-9";
export var profile = "_4-p";
export var profileContainer = "_4-q";
export var profileImage = "_4-r";
export var profileMain = "_4-s";
export var profileSubtitle = "_4-u";
export var profileTitle = "_4-t";
export var settingsSurface = "_4-a";
export var showLeftPadding = "_4-i";
export var tabsPortalSlot = "_4-6";
export var tabsWrapper = "_4-4";
export var title = "_4-v";